// @flow
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouter } from 'Client/router/useRouter';
import { hasAtLeastOnePrice } from 'Components/utils/price/price.util';
import { getProductBadgeIcon } from 'Components/utils/product/product.utils';
import ReactAppContext from 'Context/ReactAppContext';
import { priceTicketRequest } from 'Store/priceTicket/priceTicket.actions';

import {
  getPriceTicketButton,
  getPriceTicketInfo,
  getPriceTicketItems,
  getPriceTicketSubtitle,
} from './priceTicket.mapper';
import { PriceTicketContentWrapper } from './PriceTicketContentWrapper';

export const MIN_HEIGHT = '3.75rem';
export const MIN_HEIGHT_LITE = '3.1875rem';

type Props = {|
  cruise: null | Cruise,
  product: Resort,
  travelAdvisorConfig: CMSTravelAdvisor,
|};

export const PriceTicket = ({ cruise, product, travelAdvisorConfig }: Props) => {
  const appContext = React.useContext(ReactAppContext);
  const { location } = useRouter<ProductUrlParams, ProductQueryParams>();
  const isLoading = useSelector<boolean>(state => state.priceTicket.isLoading);
  const price = useSelector<ProductPrice>(state => state.priceTicket.price);
  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(priceTicketRequest(appContext, location, product.id));
    },
    [product.id],
  );

  return (
    <PriceTicketContentWrapper
      badgeIcon={getProductBadgeIcon(product)}
      button={getPriceTicketButton(product)}
      hasCallCenter={!hasAtLeastOnePrice(price)}
      info={getPriceTicketInfo(product)}
      isLoading={isLoading}
      items={getPriceTicketItems({
        price,
        product,
      })}
      price={price}
      subtitle={getPriceTicketSubtitle(product, cruise)}
      title={product.name}
      travelAdvisorConfig={travelAdvisorConfig}
    />
  );
};
